import { render } from "./Confirm.vue?vue&type=template&id=c73b250e&scoped=true&ts=true"
import script from "./Confirm.vue?vue&type=script&lang=ts"
export * from "./Confirm.vue?vue&type=script&lang=ts"

import "./Confirm.vue?vue&type=style&index=0&id=c73b250e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c73b250e"]])

export default __exports__